"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promisify = exports.sleep = exports.uniqueId = void 0;
var crypto = require("crypto");
function uniqueId() {
  return crypto.randomBytes(16).toString('hex');
}
exports.uniqueId = uniqueId;
function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
exports.sleep = sleep;
function promisify(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new Promise(function (resolve, reject) {
      fn.apply(null, args.concat(function (err) {
        if (err) {
          reject(err);
        } else {
          for (var _len2 = arguments.length, results = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            results[_key2 - 1] = arguments[_key2];
          }
          resolve.apply(null, results);
        }
      }));
    });
  };
}
exports.promisify = promisify;